import { Box, BoxProps, styled } from "@mui/material";
import { FC } from "react";

import { divider } from "@/modules/irohana-components/theme/colors";

export type TDividerVariant = "solid" | "dashed" | "dotted";
export type TDividerWeight = "thin" | "light" | "regular" | "medium" | "bold" | "heavy";
export type TDividerOrientation = "horizontal" | "vertical";

export type TDividerProps = {
  variant?: TDividerVariant;
  weight?: TDividerWeight;
  orientation?: TDividerOrientation;
  color?: string;
} & Omit<BoxProps, "color">;

const weightMap: Record<TDividerWeight, number> = {
  thin: 0.5,
  light: 1,
  regular: 1.5,
  medium: 2,
  bold: 3,
  heavy: 4,
};

export const Divider: FC<TDividerProps> = ({ variant = "solid", weight = "light", orientation = "horizontal", color = divider.high, ...rest }) => {
  return <StyledDivider dividerVariant={variant} dividerWeight={weightMap[weight]} dividerOrientation={orientation} dividerColor={color} {...rest} />;
};

const options = {
  shouldForwardProp: (propName: string) => !["dividerVariant", "dividerWeight", "dividerOrientation", "dividerColor"].includes(propName),
};

const StyledDivider = styled(Box, options)<{
  dividerVariant: TDividerVariant;
  dividerWeight: number;
  dividerOrientation: TDividerOrientation;
  dividerColor: string;
}>`
  ${({ dividerOrientation, dividerVariant, dividerWeight, dividerColor }) =>
    dividerOrientation === "horizontal"
      ? `
        width: 100%;
        height: 0;
        border-top: ${dividerWeight}px ${dividerVariant} ${dividerColor};
      `
      : `
        height: 100%;
        width: 0;
        border-left: ${dividerWeight}px ${dividerVariant} ${dividerColor};
      `}
`;
